export default __webpack_public_path__ + "static/media/PaulinAlcoserResume.15be6e0b.pdf";